/* esm.sh - @scure/base@2.2.0 */
export * from "/*@scure/base@2.2.0/esnext/base.mjs";
